import type { CompactionStreamStatus } from '../types/chat';
import { SSEResponseTypes } from '../../../models/websockets.types';

const COMPACTION_LABELS: Record<CompactionStreamStatus, string> = {
  started: 'Conversation compaction',
  completed: 'Conversation compacted',
  failed: 'Conversation compaction failed',
};

export function compactionStatusFromEventType(
  type: string | undefined
): CompactionStreamStatus | null {
  switch (type) {
    case SSEResponseTypes.CONVERSATION_COMPACTION_STARTED:
      return 'started';
    case SSEResponseTypes.CONVERSATION_COMPACTION_COMPLETED:
      return 'completed';
    case SSEResponseTypes.CONVERSATION_COMPACTION_FAILED:
      return 'failed';
    default:
      return null;
  }
}

export function getCompactionStreamStatusLabel(status: CompactionStreamStatus): string {
  return COMPACTION_LABELS[status];
}
